import axios from "axios";
const instance = axios.create({
  baseURL:
    window.location.host === "ono.ag" || window.location.host === "onoark.com"
      ? "https://api.onoark.com/v1/admin"
      : "https://dev-api.onoark.com/v1/admin",
});
instance.defaults.headers.common["Content-Type"] = "application/json";
export default instance;
